import { Component } from "@angular/core";
import { FloorplanFreeTextMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-text-menu/floorplan-free-text-menu/floorplan-free-text-menu.component";
import { FloorplanNotesMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-text-menu/notes-menu/floorplan-notes-menu.component";

@Component({
  selector: "app-floorplan-annotation-menu",
  imports: [FloorplanFreeTextMenuComponent, FloorplanNotesMenuComponent],
  templateUrl: "./floorplan-annotation-menu.component.html",
  styleUrl: "./floorplan-annotation-menu.component.scss",
})
export class FloorplanAnnotationMenuComponent {}
